export const path = {
  HOME: "/",
  VISA_APPLICATION: "/visa-application",
  CHOOSE_COUNTRY: "/choose-country",
  CONTACT: "/contact",
  REQUIREMENTS: "/requirements",
  VISA_REQUIREMENT_DETAILS: "/visa-requirement-details",
  PROCESSING_TIME: "/requirements/processing-time",
  PROFILE_SEARCH: "/profile-search",
  PROFILE_RESULT: "/profile-result",
  INSTRUCTION: "/instruction",
  NEWS: "/news",
  NEWS_DETAIL: "/news-detail",
  FAQ: "/faq",
  ERROR: "*",
  VIEW_VISA: "/view-visa",
  POLICY: "/policy",
  OUR_SERVICES: "/our-services",
  EMERGENCY_INQUIRY: "/emergency-inquiry",
  ABOUT_US: "/about-us",
  TRANSPORTATION: "/transportation",
};
